import { MediaGridContext } from '../MediaGrid/MediaGrid.view';
import { ContainerListItem } from '../../../../components/actions/ListItem/ListItem.view';
import { MediaItem } from '../../../../models/media';

export type GridItemActionType = (media: MediaItem[]) => void;

export type ActionProperties =
  | {
      context: MediaGridContext.PAGE | MediaGridContext.FIND_IMAGES;
      primaryAction: (media: MediaItem[]) => void;
      secondaryAction: (media: MediaItem[]) => void;
      lightBoxAction?: CallableFunction;
    }
  | {
      context: MediaGridContext.MODAL;
      primaryAction: (media: MediaItem[]) => void;
      secondaryAction?: never;
      lightBoxAction?: CallableFunction;
    }
  | {
      context: MediaGridContext.POST_EDITOR_FIND_IMAGES | MediaGridContext.POST_EDITOR_MEDIA_LIBRARY;
      primaryAction?: never;
      secondaryAction?: never;
      lightBoxAction?: never;
    };

const getContainerListItem = (action: GridItemActionType | undefined, label: string): ContainerListItem | undefined => {
  return action
    ? {
        action,
        label
      }
    : undefined;
};

const ViewLargerListItem = (action: CallableFunction | undefined): ContainerListItem | undefined => {
  return action
    ? {
        action: () => action(),
        label: 'View Larger'
      }
    : undefined;
};

const MediaLibraryPageActionMenuList = (
  primaryAction: GridItemActionType,
  secondaryAction: GridItemActionType,
  lightBoxAction?: CallableFunction
): ContainerListItem[] => {
  const primary = getContainerListItem(primaryAction, 'Share in Post');
  const secondary = getContainerListItem(secondaryAction, 'Delete');
  const lightBox = ViewLargerListItem(lightBoxAction);

  return [primary, lightBox, secondary].flatMap(item => item ?? []);
};

const MediaLibraryModalActionMenuList = (
  primaryAction?: GridItemActionType,
  lightBoxAction?: CallableFunction
): ContainerListItem[] => {
  const primary = getContainerListItem(primaryAction, 'Add to Post');
  const lightBox = ViewLargerListItem(lightBoxAction);

  return [primary, lightBox].flatMap(item => item ?? []);
};

const FindImagesMediaLibraryActionMenuList = (
  primaryAction?: GridItemActionType,
  secondaryAction?: GridItemActionType,
  lightBoxAction?: CallableFunction
): ContainerListItem[] => {
  const primary = getContainerListItem(primaryAction, 'Share in Post');
  const secondary = getContainerListItem(secondaryAction, 'Add to Library');
  const lightBox = ViewLargerListItem(lightBoxAction);

  return [primary, lightBox, secondary].flatMap(item => item ?? []);
};

export const ActionMenuListView = (props: ActionProperties): ContainerListItem[] => {
  const { context, primaryAction, secondaryAction, lightBoxAction } = props;
  switch (context) {
    case MediaGridContext.PAGE:
      return MediaLibraryPageActionMenuList(primaryAction, secondaryAction, lightBoxAction);
    case MediaGridContext.MODAL:
      return MediaLibraryModalActionMenuList(primaryAction, lightBoxAction);
    case MediaGridContext.FIND_IMAGES:
      return FindImagesMediaLibraryActionMenuList(primaryAction, secondaryAction, lightBoxAction);
    case MediaGridContext.POST_EDITOR_FIND_IMAGES:
    case MediaGridContext.POST_EDITOR_MEDIA_LIBRARY:
    default:
      return [];
  }
};
